import { cn } from '../../lib/cn';
import { Chip } from '../design-system/Chip';
import { useNudgeImpression } from '../../hooks/useNudgeImpression';
import type { FastagProfile } from '../../types';
import { formatCurrency } from '../../utils/format';

interface NudgeHeaderChipProps {
  profile: FastagProfile;
  visible: boolean;
}

export function NudgeHeaderChip({ profile, visible }: NudgeHeaderChipProps) {
  useNudgeImpression('nudge_header_chip', visible, { balance: profile.balance });

  if (!visible) return null;

  const isNegative = profile.balance < 0;
  const isLow = profile.balance >= 0 && profile.balance < 100;
  const isPredicted = profile.predictedLow;

  let variant: 'error' | 'warning' | 'primary' = 'primary';
  let label: string;

  if (isNegative) {
    variant = 'error';
    label = `FASTag ${formatCurrency(profile.balance)}`;
  } else if (isLow) {
    variant = 'warning';
    label = `FASTag ${formatCurrency(profile.balance)}`;
  } else if (isPredicted) {
    variant = 'primary';
    label = 'FASTag running low';
  } else {
    label = 'FASTag low';
  }

  return (
    <button
      className={cn(
        'touch-target inline-flex items-center rounded-full transition-transform hover:scale-105 focus-visible:ring-2 focus-visible:ring-park-500 focus-visible:ring-offset-2'
      )}
      aria-label={`FASTag balance ${formatCurrency(profile.balance)}, recharge recommended`}
    >
      <Chip variant={variant} size="md" dot className="shrink-0">
        {label}
      </Chip>
    </button>
  );
}
